/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetMatchesMatchidChampionPoolsQueryResponse,
  GetMatchesMatchidChampionPoolsPathParams,
} from "../types/GetMatchesMatchidChampionPools.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getMatchesMatchidChampionPoolsQueryKey = (
  matchId: GetMatchesMatchidChampionPoolsPathParams["matchId"] | undefined,
) =>
  [
    { url: "/matches/:matchId/champion-pools", params: { matchId: matchId } },
  ] as const;

export type GetMatchesMatchidChampionPoolsQueryKey = ReturnType<
  typeof getMatchesMatchidChampionPoolsQueryKey
>;

/**
 * @summary KAN-1676: пулы чемпионов матча (RandomDraft). Доступны всем — как /draft у пре-драфта:
 * пулы публичны для обеих команд и зрителей, включая стрим.
 * {@link /matches/:matchId/champion-pools}
 */
export async function getMatchesMatchidChampionPools(
  matchId: GetMatchesMatchidChampionPoolsPathParams["matchId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetMatchesMatchidChampionPoolsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/matches/${matchId}/champion-pools`,
    ...requestConfig,
  });
  return res;
}

export function getMatchesMatchidChampionPoolsQueryOptions(
  matchId: GetMatchesMatchidChampionPoolsPathParams["matchId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getMatchesMatchidChampionPoolsQueryKey(matchId);
  return queryOptions<
    ResponseConfig<GetMatchesMatchidChampionPoolsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetMatchesMatchidChampionPoolsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!matchId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getMatchesMatchidChampionPools(matchId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary KAN-1676: пулы чемпионов матча (RandomDraft). Доступны всем — как /draft у пре-драфта:
 * пулы публичны для обеих команд и зрителей, включая стрим.
 * {@link /matches/:matchId/champion-pools}
 */
export function useGetMatchesMatchidChampionPools<
  TData = ResponseConfig<GetMatchesMatchidChampionPoolsQueryResponse>,
  TQueryData = ResponseConfig<GetMatchesMatchidChampionPoolsQueryResponse>,
  TQueryKey extends QueryKey = GetMatchesMatchidChampionPoolsQueryKey,
>(
  matchId: GetMatchesMatchidChampionPoolsPathParams["matchId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetMatchesMatchidChampionPoolsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getMatchesMatchidChampionPoolsQueryKey(matchId);

  const query = useQuery(
    {
      ...getMatchesMatchidChampionPoolsQueryOptions(matchId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
